import FornecedorEmailService from "@/services/FornecedorEmailService";

export const fornecedorEmail = {
  namespaced: true,
  state: {
    fornecedorEmail: {},
  },
  actions: {
    getFornecedorEmail({ commit }, payload) {
      return FornecedorEmailService.GetFornecedorEmail(payload).then(
        (fornecedorEmail) => {
          return Promise.resolve(fornecedorEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postFornecedorEmail({ commit }, payload) {
      return FornecedorEmailService.PostFornecedorEmail(payload).then(
        (fornecedorEmail) => {
          return Promise.resolve(fornecedorEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putFornecedorEmail({ commit }, payload) {
      return FornecedorEmailService.PutFornecedorEmail(payload).then(
        (fornecedorEmail) => {
          return Promise.resolve(fornecedorEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteFornecedorEmail({ commit }, payload) {
      return FornecedorEmailService.DeleteFornecedorEmail(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getFornecedorEmailOData({ commit }, payload) {
      return FornecedorEmailService.GetFornecedorEmailOData(payload).then(
        (fornecedorEmail) => {
          return Promise.resolve(fornecedorEmail);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default fornecedorEmail;
